class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      languageInput: this.querySelector('input[name="locale_code"]'),
      panel: this.querySelector('[data-select-list]'),
    };

    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    // This will make sure that the language is updated to the language of the
    // market, to prevent the market/domain being switched, but still being on
    // the same language (primarily when going from primary DE language to
    // another market that has DE available as language.).
    this.elements.languageInput.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

class LocalizationBanner extends HTMLElement {
  connectedCallback() {
    const LOCALIZATION_BANNER_SHOWN = 'localization_banner_shown';

    // Check if banner should be shown based on language and local storage
    if (
      navigator.language.toLowerCase().startsWith(window.Shopify.locale.toLowerCase()) === false &&
      localStorage.getItem(LOCALIZATION_BANNER_SHOWN) === null
    ) {
      // Get delay from dataset or use default 1000ms
      const delay = (this.dataset.delay || 1) * 1000;

      // Show banner after delay
      setTimeout(() => {
        this.classList.add('active');
        localStorage.setItem(LOCALIZATION_BANNER_SHOWN, 'true');
      }, delay);
    }

    // Close banner
    this.querySelector('[data-close-banner]').addEventListener('click', () => {
      this.classList.remove('active');
    });
  }

  // Debug localization
  debugLocalization() {
    console.group('Localization Debug Info');
    console.log('Current navigator language:', navigator.language);
    console.log('Store locale:', window.Shopify.locale);
    console.log(
      'Banner previously shown:',
      localStorage.getItem('localization_banner_shown') === null ? 'No' : 'Yes'
    );
    console.log(
      'Should show banner:',
      navigator.language.toLowerCase().startsWith(window.Shopify.locale.toLowerCase()) === false &&
        localStorage.getItem('localization_banner_shown') === null
    );
    console.log('Delay:', this.dataset.delay);
    console.groupEnd();
  }
}

// Expose debugLocalization globally
window.debugLocalization = () => {
  const banner = document.querySelector('localization-banner');
  if (banner) ; else {
    console.error('Localization banner element not found');
    banner.debugLocalization();
  }
};

// Define custom elements
customElements.define('localization-form', LocalizationForm);
customElements.define('localization-banner', LocalizationBanner);
